<script setup>
import FormError from "@/components/molecules/form/form-error";
import apiDriveCommande from "@/services/http/api-drive/client/commande";
import apiDriveMagasin from "@/services/http/api-drive/magasin";
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import { useContextStore } from "@/store/context";
import { useClientStore } from "@/store/client";

definePageMeta({
  middleware: "authenticated"
});

const { trackPage } = useTrackingPage();

onMounted(() => {
  trackPage(trackingCodes.PAGETYPE.monCompte);
});

const app = useNuxtApp();
const { query, params } = useRoute();
const { getAxiosErrorFromAsyncData, throwIfAxiosError } = useAxiosHelper();

const { layout } = storeToRefs(useContextStore());
const { isPorteurCarteCora, isPorteurCarteMalin, isPro, isEligibleDefis } =
  storeToRefs(useClientStore());
const { setPopinAjoutCarteVisible } = useClientStore();

const error = ref(null);
const magasin = ref();
const commande = ref();

const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[
      `/components/organisms/mon-compte/commande-detail/${layout.value}.vue`
    ]
  );
});

const archive = query.archive ? query.archive : 0;

const { data: res, error: commandeError } = await useAsyncData((app) =>
  app.$apiDrive.use(apiDriveCommande).commande(params.id, { archive })
);
throwIfAxiosError(commandeError);

const { data, meta } = res.value;

commande.value = data;

const { data: mag, eror: magasinError } = await useAsyncData((app) =>
  app.$apiDrive
    .use(apiDriveMagasin)
    .magasin(commande.value.attributes.magasin_id)
);
throwIfAxiosError(magasinError);

magasin.value = mag ? mag.value.data : null;
const sections = meta.sections.valeurs;

if (
  query &&
  query.downloadPDF &&
  commande.value.attributes.label_bon_ticket &&
  commande.value.attributes.label_bon_ticket.url
) {
  const { data, error: ticketError } = await useAsyncData((app) =>
    app.$apiDrive.get(commande.value.attributes.label_bon_ticket.url)
  );
  if (ticketError.value) {
    error.value = app.$apiDrive.getErrorData(
      getAxiosErrorFromAsyncData(ticketError)
    );
  }
  if (data.value && data.value.data.url) {
    window.location.href = data.value.data.url;
  }
}
</script>

<template>
  <div>
    <FormError
      v-if="error"
      :error="error"
    />
    <component
      :is="component"
      :commande="commande"
      :sections="sections"
      class="u-mt-md"
      :magasin="magasin"
      :is-porteur-carte-cora="isPorteurCarteCora"
      :is-porteur-carte-malin="isPorteurCarteMalin"
      :is-pro="isPro"
      :is-eligible-defis="isEligibleDefis"
      @setPopinAjoutCarteVisible="setPopinAjoutCarteVisible"
    />
  </div>
</template>
